module.exports = __webpack_public_path__ + "static/media/arrow_7.92d5c1b1.svg";